import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AwbConfigComponent } from 'src/app/components/system-config/awb/awbconfig.component';
import { Page404Component } from 'src/app/components/page404/page404.component';
import { InvoiceSeriesComponent } from 'src/app/components/system-config/invoice-series/invoiceseries.component';
import { AddTaxesComponent } from 'src/app/components/system-config/taxes/add/add.component';
import { TemplatesComponent } from 'src/app/components/system-config/templates/templates.component';
import { CreditControlComponent } from 'src/app/components/system-config/credit-control/creditcontrol.component';
import { TATComponent } from 'src/app/components/system-config/tat/tat.component';
import { DiscountComponent } from 'src/app/components/system-config/discount/discount.component';
import { DataImportComponent } from 'src/app/components/system-config/data-import/data-import.component';
import { ListVendorAWBComponent } from 'src/app/components/system-config/vendor-awb/list/list.component';
import { AddVendorAWBComponent } from 'src/app/components/system-config/vendor-awb/add/add.component';
import { EditVendorAWBComponent } from 'src/app/components/system-config/vendor-awb/edit/edit.component';
const routes: Routes = [
  { path: 'awb', component: AwbConfigComponent },
  { path: 'taxes', component: AddTaxesComponent },
  { path: 'charges', loadChildren: () => import('./charges/charges.module').then(c => c.ChargesModule) },
  { path: 'invoiceseries', component: InvoiceSeriesComponent },
  { path: 'templates', component: TemplatesComponent },
  { path: 'creditcontrol', component: CreditControlComponent },
  { path: 'tat', component: TATComponent },
  { path: 'discount', component: DiscountComponent },
  { path: 'import',component: DataImportComponent},
  { path: 'vendorawb',component: ListVendorAWBComponent},
  { path: 'vendorawb/add',component: AddVendorAWBComponent},
  { path: 'vendorawb/edit/:id',component: EditVendorAWBComponent},
  { path: '', component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigRoutingModule { } 